var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgGroup4 = function SvgGroup4(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#579FD7",
    d: "M2.874 16.169c-.951 0-1.725.773-1.725 1.724 0 .95.774 1.724 1.725 1.724.95 0 1.724-.774 1.724-1.724 0-.951-.774-1.724-1.724-1.724zm0 2.298c-.317 0-.575-.257-.575-.574 0-.317.258-.575.575-.575.316 0 .574.258.574.575 0 .317-.258.574-.574.574zm11.494-2.298c-.95 0-1.724.773-1.724 1.724 0 .95.773 1.724 1.724 1.724.95 0 1.724-.774 1.724-1.724 0-.951-.773-1.724-1.724-1.724zm0 2.298c-.317 0-.575-.257-.575-.574 0-.317.258-.575.575-.575.316 0 .575.258.575.575 0 .317-.259.574-.575.574z",
    transform: "translate(7 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7D9FF",
    d: "M16.667 0c-.318 0-.575.257-.575.575v6.398H1.149V.575C1.15.257.892 0 .575 0 .257 0 0 .257 0 .575v16.168c0 .318.257.575.575.575h16.092c.317 0 .574-.257.574-.575V.575c0-.318-.257-.575-.574-.575zm-.575 13.87H1.149V8.123h14.943v5.747z",
    transform: "translate(7 6)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGroup4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/group_4.540841c7.svg";
export { ForwardRef as ReactComponent };